

import React from "react";
import { BrowserRouter, Switch, Redirect, Route, Link, NavLink } from "react-router-dom";

import { Header } from '../../Components/Layout/Header.jsx'
import { GameDetails } from '../../Components/Game/GameDetails.jsx'
import { ObavijestiCasino } from '../../Components/Layout/ObavijestiCasino.jsx'
import { Game } from '../../Components/Game/Game.jsx'

import { TrajanjePromocije } from '../../Components/Layout/TrajanjePromocije.jsx'
import { BonusPobjednici } from '../../Components/Layout/BonusPobjednici.jsx'
import { MetaTags } from '../../Components/Layout/MetaTags.jsx'

export class BonusesValentinovo extends React.Component {


    constructor(props) {
        super(props);
        this.state = { tabs: ['Nagrade', 'Ljubavne igre', 'Rezultati'], selectedTab: null, igre: null,kampanja:null }


        this.setData = this.setData.bind(this);
        this.gotoTab = this.gotoTab.bind(this);
        this.renderIgra = this.renderIgra.bind(this);
        this.dohvatiBonusIgre = this.dohvatiBonusIgre.bind(this);

        casino.utils.createPageGoogleTagManagerEvent('Bonusi', 'Valentinovo', 'casino', this.props.user);
    }

    componentDidMount() {
        window.scrollTo(0, 0);
        this.props.showMenuFn(false);
        this.gotoTab(this.state.tabs[0]);

        this.props.showLoadingFn(true);
        var promises = Promise.all([casino.repos.gameRepo.list().then(this.props.unpackGamesListFn), casino.repos.categoryRepo.list().then(this.props.saveCategoriesFn),casino.repos.casinoBonusRepo.get('NajveciBrojSpinovaValentinovo2022')]);
        this.dataPromises = casino.utils.makeCancelablePromise(promises);
        this.dataPromises.promise.then(this.setData, function (reason) { });
    }
    componentWillUnmount() {
        this.dataPromises.cancel();
        this.props.showLoadingFn(false);
    }

    setData(data) {
        var [igre, kategorije, kampanja] = data;
        this.setState({
            igre: igre,
            categories: kategorije.items,
            kampanja : kampanja
        });
        this.props.showLoadingFn(false);
    }

    gotoTab(tab) {
        this.setState({ selectedTab: tab });
    }


    renderIgra(igra) {
        return <Game brands={this.props.brands} categories={this.state.categories} key={igra.sifra} igra={igra} showJackpot={false} routePrefix='/promotions/valentinovo' />

    }
    dohvatiBonusIgre() {
        var that = this;


        return this.state.igre.filter(function (igra) {
            return that.state.kampanja.igreSifre.indexOf(igra.sifra) != -1;
        });

    }

    setPlace(nagrada, index) {
        if (nagrada.mjesto - this.state.kampanja.nagrade[index-1].mjesto >= 2){
            return `${this.state.kampanja.nagrade[index-1].mjesto+1}.-${nagrada.mjesto}. mjesto`;
        } else if (nagrada.mjesto - this.state.kampanja.nagrade[index-1].mjesto == 1) {
            return `${nagrada.mjesto }. mjesto`;
        } 
    }

    getUTCDate(d) {
        let date = new Date(d);
        return Date.UTC(date.getUTCFullYear(), date.getUTCMonth(), date.getUTCDate(),date.getUTCHours(), date.getUTCMinutes(), date.getUTCSeconds());
    }


    render() {
        return <div >
            <MetaTags title="Bonusi - SuperSport CASINO" description="Game race bonusi u SuperSport CASINU!" />
            <Header key="header" {...this.state} {...this.props}></Header>
            <div className='white-background'>
                <div className="banner banner2">
                    <section className="valentinovo2019-2 banner--inner selected">
                        <div className="banner--content">
                            <div className="banner--bg-container">
                                <div className="banner--repeater" />
                                <div className="banner--background" />
                                {/* <div className="banner--mask-white" /> */}
                            </div>
                            <div className="banner--foreground">
                                <div className="banner--image">
                                </div>
                            </div>
                        </div>
                    </section>
                    {this.state.kampanja &&  <TrajanjePromocije pocetakPromocije={this.getUTCDate(this.state.kampanja.aktivnoOd)} krajPromocije={this.getUTCDate(this.state.kampanja.aktivnoDo)} extraClass="valentinovo" />}
                </div>
                <div id="page-wrapper" className="max-width-70 margin-center no-padding-on-mobile" style={{ position: 'static' }}>
                    <div className='margin-top margin-bottom'> &nbsp;</div>



                    <div className="padding-sides-medium-2 hallowen-bonus-promocija " style={{ backgroundColor: '#130504', color: '#e0b5bc' }}>
                        <div className='mobile-visible'><div style={{ height: '12px' }}></div></div>
                        <div className=''><div style={{ height: '10px' }}></div></div>
                        <h2 className='v4 margin-bottom-small' style={{ color: '#fffffb' }}>IGRAJ! NAJVEĆI DOBITAK DOBIVA DUPLO</h2>
                        <span style={{ color: '#e0b5bc' }}>
                            <img src='content/images/bonusi/img_S_2x.png' className="skulls"></img>
                            <span>Poduplat ćemo najveći dobitak na spinu iz Valentinovo igara (koji nije jackpot). Zaigraj i ako imaš najveći dobitak, imaš i  <span style={{ color: '#fffffb' }}><b>dvostruko više</b> </span> razloga za slavlje!</span>
                        </span>
                    </div>

                    <div className="padding-sides-medium-2 border-top-small white-background">
                        <h2 className='v9 margin-bottom-small'>Valentinovo! 💘</h2>
                        <p>Zaigraj <i>ljubavne</i> igre od <b>{casino.utils.dateToShortDateString(new Date(this.state.kampanja?.aktivnoOd))} u {casino.utils.dateToTimeString(new Date(this.state.kampanja?.aktivnoOd))} do {casino.utils.dateToShortDateString(new Date(this.state.kampanja?.aktivnoDo))} u {casino.utils.dateToTimeString(new Date(this.state.kampanja?.aktivnoDo))}</b> i utrkuj se.</p>
                        <p>Igrače koji u navedenom periodu izvrte najveći broj ljubavnih spinova od najmanje {casino.utils.switchKnToEur(this.state.kampanja?.minimalniUlog) + ' ' + casino.utils.switchCurrencyKnToEur()} očekuju <b>vrijedne nagrade </b>...</p>

                        <div className='margin-bottom-small'>&nbsp;</div>
                        <div className="segment v2">
                            {this.state.tabs && this.state.tabs.map((tab) =>
                                <button key={tab} onClick={() => this.gotoTab(tab)} className={'segment--btn' + (this.state.selectedTab === tab ? ' selected' : '')}><span>{tab}</span></button>
                            )}
                        </div>
                    </div>

                    {this.state.selectedTab == 'Nagrade' &&
                        <div>
                            <h2 className='v4 margin-bottom-small margin-top padding-sides-medium-2  '></h2>
                            <div className='padding-sides-medium-2 max-width-70 text-center   '>

                                <div className='bonus-badge gold max-width-35 as-inline-block '>
                                    <img src='content/images/bonusi/img_award_gold@2x.png' />
                                    <div className='bonus-badge--footer'>
                                    <span>1. mjesto</span>
                                    <span className="bonus-badge--footer--iznos">{this.state.kampanja && casino.utils.switchKnToEur(this.state.kampanja.nagrade[0].iznos) + ' ' + casino.utils.switchCurrencyKnToEur()}</span>
                                    </div>
                                </div>
                                <div className='bonus-badge silver max-width-35 as-inline-block'>
                                    <img src='content/images/bonusi/img_award_silver@2x.png' />
                                    <div className='bonus-badge--footer'>
                                    <span>2. mjesto</span>
                                    <span className="bonus-badge--footer--iznos">{this.state.kampanja && casino.utils.switchKnToEur(this.state.kampanja.nagrade[1].iznos) + ' ' + casino.utils.switchCurrencyKnToEur()}</span>
                                    </div>
                                </div>
                                
                                <div className='bonus-badge bronze max-width-35 as-inline-block'>
                                    <img src='content/images/bonusi/img_award_bronze@2x.png' />
                                    <div className='bonus-badge--footer'>
                                    <span>3. mjesto</span>
                                    <span className="bonus-badge--footer--iznos">{this.state.kampanja && casino.utils.switchKnToEur(this.state.kampanja.nagrade[2].iznos) + ' ' + casino.utils.switchCurrencyKnToEur()}</span>
                                    </div>
                                </div>

                            </div>
                            <table className="margin-top table-1 v2 margin-bottom  max-width-70">
                                <tbody>
                                    {this.state.kampanja && this.state.kampanja.nagrade.map((nagrada, index) => 
                                         (index > 2 && <tr key={index} className={index > 3 ? 'horizontal-lines' : ''}>
                                        <td className='text text-1'>{this.setPlace(nagrada, index)}</td>
                                        <td className='text text-1  text-bold text-right'>{casino.utils.switchKnToEur(nagrada.iznos) + ' ' + casino.utils.switchCurrencyKnToEur()}</td>
                                        </tr>)         
                                        )}
                                </tbody>
                            </table>
                        </div>}




                    {this.state.selectedTab == 'Rezultati' &&
                        <div>
                            {/* <h2 className='v4 margin-bottom-small margin-top padding-sides-medium-2'>Trenutni poredak</h2> */}
                            <div className="margin-top">
                                {this.state.kampanja?.nagrade && <BonusPobjednici {...this.props} aktivno={true} najveciBrojSpinovaID={36} podebljajNajveciDobitakID={37} sifra='casinoBonus' aktivniBodoviText='Spinova' hidePrethodni={true} />}
                            </div>
                            <div className='padding-sides-medium-2 text-left text text-6 margin-top-small '>
                                * rezultati se osvježavaju svakih 5 minuta
                                    <br />

                                <br />
                            </div>
                        </div>}





                    {this.state.selectedTab == 'Ljubavne igre' && this.state.kampanja?.igreSifre &&
                        <div>
                            {/* <h2 className='v4 margin-bottom-small margin-top padding-sides-medium-2'>Jezive igre</h2> */}
                            <div className="margin-top">

                                <div className="clearfix games-container white">
                                    <div>
                                        {
                                            this.state && this.state.igre ?
                                                this.dohvatiBonusIgre().map(this.renderIgra) :
                                                <div>Dohvaćanje igara...</div>
                                        }
                                    </div>
                                </div>

                            </div>

                        </div>}
                    {this.state.selectedTab != 'Rezultati' &&

                        <div className="text-center">
                            {/* <hr /> */}
                            <a className="btn medium fill gray blue margin-top margin-bottom no-text-transform" target="_blank" href={`${casino.config.casinoCDNDocumentsUrl}/Pravila/ss_valentinovo2022.pdf?c=${casino.config.guiCacheVerzija}`}>
                                <span >Pravila igre</span> <span className="icon ico-expand-outline"></span>
                            </a>
                        </div>
                    }


                </div>
            </div>
            <GameDetails {...this.props} {...this.state} routePrefix="/promotions/valentinovo"></GameDetails>
            <ObavijestiCasino {...this.props}></ObavijestiCasino>
        </div>


    }
};
